"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var content_shifter_scss_1 = tslib_1.__importDefault(require("./content-shifter.scss"));
var ContentShifter = /** @class */ (function (_super) {
    tslib_1.__extends(ContentShifter, _super);
    function ContentShifter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentShifter.prototype.getTransformValue = function () {
        var _a = this.props, active = _a.active, width = _a.width, itemWidth = _a.itemWidth, inFrameItemsCount = _a.inFrameItemsCount, reduceMarginsBy = _a.reduceMarginsBy, isRTL = _a.isRTL;
        var translateX = (width - inFrameItemsCount * itemWidth + reduceMarginsBy * 2) *
            (isRTL ? -1 : 1);
        return active ? "translate3d(".concat(translateX, "px, 0, 0)") : '';
    };
    ContentShifter.prototype.render = function () {
        var _a = this.props, children = _a.children, reduceMarginsBy = _a.reduceMarginsBy;
        return (react_1.default.createElement("div", { "data-hook": "content-shifter", className: content_shifter_scss_1.default.container, style: {
                transform: this.getTransformValue(),
                margin: "0 ".concat(-reduceMarginsBy, "px"),
            } }, children));
    };
    ContentShifter.defaultProps = {
        reduceMaringsBy: 0,
    };
    return ContentShifter;
}(react_1.default.Component));
exports.default = ContentShifter;
//# sourceMappingURL=content-shifter.js.map